// extracted by mini-css-extract-plugin
module.exports = {"devices":"devices-list_devices__1X_Vs","devicesMainPage":"devices-list_devicesMainPage__1A11v"};